module.exports = __webpack_public_path__ + "img/galeria-ornamentales-4.cf07437a.jpg";